import { motion } from 'framer-motion';
import { TrendingDown, AlertTriangle, DollarSign } from 'lucide-react';
import '../styles/sections.css';
import './Problem.css';

const stats = [
  {
    icon: <TrendingDown size={24} />,
    value: '~95%',
    label: 'of enterprise generative-AI pilots deliver no measurable P&L return',
    source: 'MIT Project NANDA, 2025',
  },
  {
    icon: <AlertTriangle size={24} />,
    value: '80%+',
    label: 'of AI projects fail — roughly twice the rate of conventional IT projects',
    source: 'RAND Corporation',
  },
  {
    icon: <DollarSign size={24} />,
    value: '80–90%',
    label: 'of AI spend is now inference, with agentic workflows costing 5–25× more than chat',
    source: '2026 AI cost economics',
  },
];

export default function Problem() {
  return (
    <section id="problem" className="section sectionAlt">
      <div className="container">
        <div className="sectionHeader">
          <span className="sectionLabel">The Problem</span>
          <h2 className="sectionTitle">Most enterprise AI never ships — and the bill arrives anyway.</h2>
          <p className="sectionSubtitle">
            Non-deterministic LLMs produce plausible-but-wrong output that regulated buyers cannot
            ship. Meanwhile, inference costs have exploded, and the gap between demos and production
            keeps widening.
          </p>
        </div>

        <div className="statsGrid">
          {stats.map((stat, idx) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ duration: 0.6, delay: idx * 0.12 }}
              className="statCard glassCard"
            >
              <div className="iconWrap">{stat.icon}</div>
              <div className="statValue">{stat.value}</div>
              <p className="statLabel">{stat.label}</p>
              <span className="statSource">{stat.source}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
